module.exports = __webpack_public_path__ + "static/img/Roberts.c338d23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Roberts.jpg
// module id = hpJ1
// module chunks = 0